
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/designers",
      function () {
        return require("private-next-pages/designers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/designers"])
      });
    }
  